var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiCheckLtr = function SvgUiCheckLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M94.6 13.919a3.16 3.16 0 0 1 4.487.033 3.207 3.207 0 0 1 .04 4.44l-.073.074-68.193 67.616a3.16 3.16 0 0 1-4.397.055l-.073-.072L.929 60.446a3.206 3.206 0 0 1 0-4.514 3.16 3.16 0 0 1 4.413-.072l.074.072L28.65 79.309z",
    clipRule: "evenodd"
  })));
};
export default SvgUiCheckLtr;